export default "__VITE_ASSET__1bcd17a2__"